import {
    APPLY_DEVICES_RADIO_DISABLED_ACTION,
    BRANCH_APPLY_DEVICES_RADIO_DISABLED_ACTION,
    DELIVERY_METHOD_RADIO_DISABLED_ACTION,
    EFD_EFFECTIVE_DATE_DISABLED_ACTION,
    INVOICING_EFFECTIVE_DATE_DISABLED_ACTION
} from "../../../actionType";

export default function (state = {efdEffectiveDateDisabled:true,
    invoicingEffectiveDateDisabled:true,
    applyDevicesRadioDisabled:true,
    branchApplyDevicesRadioDisabled:true,
    deliveryMethodRadioDisabled:true,}, action) {
    switch (action.type) {
        case EFD_EFFECTIVE_DATE_DISABLED_ACTION:
            return {
                ...state,
                efdEffectiveDateDisabled:action.efdEffectiveDateDisabled,
            };
        case INVOICING_EFFECTIVE_DATE_DISABLED_ACTION:
            return {
                ...state,
                invoicingEffectiveDateDisabled:action.invoicingEffectiveDateDisabled,
            };
        case APPLY_DEVICES_RADIO_DISABLED_ACTION:
            return {
                ...state,
                applyDevicesRadioDisabled:action.applyDevicesRadioDisabled,
            };
        case BRANCH_APPLY_DEVICES_RADIO_DISABLED_ACTION:
            return {
                ...state,
                branchApplyDevicesRadioDisabled:action.branchApplyDevicesRadioDisabled,
            };
        case DELIVERY_METHOD_RADIO_DISABLED_ACTION:
            return {
                ...state,
                deliveryMethodRadioDisabled:action.deliveryMethodRadioDisabled,
            };
        default:
            return state;
    }
}
